/**
 *
 * @param {*} obj
 * @param {*} cb
 * @returns
 */
const filteringObject = (obj, cb) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    cb(acc, key, value);
    return acc;
  }, {});
};

export default filteringObject;
